module.exports = __webpack_public_path__ + "static/media/ne-NP.795a6f82.md";